module.exports = __webpack_public_path__ + "static/media/white-polygon-measure-icon.b4a22da2.svg";